import projectsApi from './../../api/projects.js';
import toastr from 'toastr';
import i18n from '@/i18n.bootstrap';
import Utils from '../../Utils.js';

export default {
    loadProjectList: function({ commit }) {
        return new Promise((resolve, reject) => {
            projectsApi.loadProjectList().then(
                response => {
                    commit('setProjectList', { list: response.data });
                    resolve(response.data);
                },
                error => {
                    console.log('loadProjectList error', { ...error });
                    reject(error);
                }
            );
        });
    },

    loadProjectById: ({ commit }, { projectId }) => {
        return new Promise((resolve, reject) => {
            projectsApi.loadProjectById(projectId).then(
                response => {
                    commit('setProjectData', response.data);
                    resolve(response);
                },
                error => {
                    toastr.error(i18n.t('project.action.errorLoading', {projectId}));
                    console.log('loadProjectById error', { ...error });
                    reject(error);
                }
            );
        });
    },

    updateProject: ({ commit }, project) => {
        return projectsApi.updateProject(project).then(
            response => {
                if (response) {
                    commit('updateProject', project);
                    toastr.success(i18n.t('project.action.successUpdate'));
                }
            },
            error => {
                toastr.error(i18n.t('project.action.errorUpdate', {projectName: project.name}));
                console.log('updateProject error', { ...error }, project);
            }
        );
    },

    loadFeedByProject: ({ commit }, { projectId }) => {
        return new Promise((resolve, reject) => {
            projectsApi.loadFeedByProject(projectId).then(
                response => {
                    commit('setFeed', response.data);
                    resolve(response);
                },
                error => {
                    toastr.error(i18n.t('feed.action.errorLoadFeed', {projectId}));
                    console.log('loadFeedByProject error', { ...error });
                    reject(error);
                }
            );
        });
    },

    addFeedItem: ({ commit }, { projectId, item }) => {
        return new Promise((resolve, reject) => {
            projectsApi.addFeedItem(projectId, item).then(
                response => {
                    commit('addFeedItem', response.data);
                    resolve(response);
                },
                error => {
                    toastr.error(i18n.t('feed.action.errorAddFeed', {projectId}));
                    console.log('addFeedItem error', { ...error });
                    reject(error);
                }
            );
        });
    },

    removeFeedItem: ({ commit }, { projectId, itemId }) => {
        return new Promise((resolve, reject) => {
            projectsApi.removeFeedItem(projectId, itemId).then(
                response => {
                    if(response) {
                        commit('removeFeedItem', itemId);
                        toastr.success(i18n.t('feed.messages.action.successDelete'));
                        resolve(response);
                    }
                },
                error => {
                    toastr.error(i18n.t('feed.messages.action.errorDelete'));
                    console.log('addFeedItem error', { ...error });
                    reject(error);
                }
            )
        })
    },

    updateFeedItem: ({ commit }, { projectId, item }) => {
        return new Promise((resolve, reject) => {
            projectsApi.updateFeedItem(projectId, item).then(
                response => {
                    commit('updateFeedItem', response.data);
                    resolve(response);
                },
                error => {
                    toastr.error(i18n.t('feed.action.errorUpdateFeed', {projectId}));
                    console.log('updateFeedItem error', { ...error });
                    reject(error);
                }
            );
        });
    },

    //#region Files

    loadRawRoot: ({ dispatch, commit, state }, projectId) => {
        return new Promise((resolve, reject) => {
            dispatch('loadProjectList').then(
                () => {
                    let project = state.projects.find(item => item.id === projectId);

                    projectsApi.loadRawRoot(project.enaioRoot).then(
                        response => {
                            commit('addRawEnaioRoot', response.data);
                            resolve(response.data);
                        },
                        error => {
                            if(error.response.status !== 422)
                                toastr.error(i18n.t('files.action.errorLoading'));
                            console.error(error);
                            reject(error);
                        }
                    );
                });
        });
    },

    loadFilesByProject: ({ commit }, { projectId } ) => {
        return new Promise((resolve, reject) => {
            projectsApi.loadFilesByProject(projectId).then(
                response => {
                    // add empty children list for the nodes without children
                    // (needed for ag-grid to properly display 'no data' message)
                    Utils.initChildren(response.data);

                    commit('setFilesForProject', response.data);
                    resolve(response.data);
                },
                error => {
                    if(error.response.status !== 422)
                        toastr.error(i18n.t('files.action.errorLoading'));
                    console.log('loadFilesByProject error', { ...error });
                    reject(error);
                }
            );
        });
    },

    uploadFile: ({ commit }, { indexData, fileId, projectId, callback }) => {
        return new Promise((resolve, reject) => {
            projectsApi.uploadFile(projectId, fileId, indexData).then(
                response => {
                    commit('applyUploadedFile', { fileItem: response.data, indexData });
                    toastr.success(i18n.t('project.settings.files.uploadDialog.messages.success'));
    
                    if (callback) {
                        callback(response.data);
                    }

                    resolve(response.data);
                },
                error => {
                    console.log('Upload file error', { ...error }, indexData, fileId, projectId);
                    reject(error);
                }
            );
        });
    },

    editFile: ({ commit }, { indexData, fileId, projectId, callback }) => {
        return new Promise((resolve, reject) => {
            projectsApi.editFile(projectId, fileId, indexData).then(
                response => {
                    commit('updateFile', { fileItem: response.data, indexData });

                    if (callback) {
                        callback(response.data, true);
                    }

                    resolve(response.data);
                },
                error => {
                    console.log('Edit file error', {...error}, indexData, fileId, projectId);
                    reject(error);
                }
            )
        });
    },

    deleteFile: ({ commit }, { indexData, projectId, fileId, objectTypeId }) => {
        return new Promise((resolve, reject) => {
            projectsApi.deleteFile(projectId, fileId, objectTypeId).then(
                response => {
                    commit('removeFile', { fileId, indexData });
                    toastr.success(i18n.t('files.action.successDelete'));
                    resolve(response);
                },
                error => {
                    toastr.error(i18n.t('files.action.errorDelete'));
                    reject(error);
                }
            )
        });
    },

    //#endregion

    //#region Collaborators

    loadCollaboratorsByProject: ({ commit }, { projectId }) => {
        return new Promise((resolve, reject) => {
            projectsApi.loadCollaboratorsByProject(projectId).then(
                response => {
                    commit('setCollaboratorsForProject', response.data);
                    resolve(response);
                },
                error => {
                    toastr.error(i18n('project.action.errorLoadingCollaborators', {projectId}));
                    console.log('loadCollaboratorsByProject error', { ...error });
                    reject(error);
                }
            );
        });
    },

    removeMemberFromProject: ({ commit }, { projectId, userId }) => {
        return projectsApi.removeMemberFromProject(projectId, userId).then(
            () => {
                commit('removeUserFromGroup', userId);
            },
            error => {
                toastr.error(i18n.t('project.settings.participants.action.errorRemoveMember'));
                console.log('removeMemberFromProject error', { ...error });
            }
        );
    },

    // eslint-disable-next-line
    updateCollaboratorStatus: ({ commit }, { projectId, collaboratorStatus }) => {
        for (var key in collaboratorStatus) {
            projectsApi.updateCollaboratorStatus(projectId, key, collaboratorStatus).then(
                response => {
                    if (response) {
                        toastr.success(i18n.t('project.settings.participants.action.successUpdateMember'));
                    }
                },
                error => {
                    toastr.warning(i18n.t('project.settings.participants.action.errorUpdateMember'));
                    console.log('updateCollaboratorStatus error', { ...error }, collaboratorStatus);
                }
            );
        }
    },

    //#endregion

    //#region Tasks

    loadTaskLists: function({ commit }, { projectId }) {
        return projectsApi.loadTaskLists(projectId).then(
            response => {
                commit('setTaskLists', response.data);
            },
            error => {
                console.log('loadTaskLists error', { ...error });
            }
        );
    },

    loadProjectAssignedTaskLists: function({ commit }, { projectId }) {
        return new Promise((resolve, reject) => {
            projectsApi.loadProjectAssignedTaskLists(projectId).then(
                response => {
                    commit('setProjektAssignedTaskLists', response.data);
                    resolve(response);
                },
                error => {
                    console.log('loadProjectAssignedTaskLists error', { ...error });
                    reject(error);
                }
            );
        });
    },

    createTaskList: ({ commit }, { projectId, name }) => {
        let newTasklist = { projectId, name };
        return projectsApi.createTaskList(newTasklist).then(
            response => {
                commit('addNewTaskList', response.data, projectId);
            },
            error => {
                toastr.error(i18n.t('tasks.messages.action.errorCreateTaskGroup'));
                console.log('createTaskList error', { ...error });
            }
        );
    },

    editTaskListName: ({ commit }, { id, projectId, name }) => {
        return projectsApi.editTaskListName(id, projectId, name).then(
            () => {
                commit('editTaskListName', { id, name });
            },
            error => {
                toastr.error(i18n.t('tasks.messages.action.errorEditTaskListName'));
                console.log('editTaskListName error', { ...error });
            }
        );
    },

    deleteTaskList: ({ commit }, { listId }) => {
       return projectsApi.deleteTaskList(listId).then(
            () => {
                commit('deleteTaskList', listId);
            },
            error => {
                console.log('deleteTaskList error', { ...error });
            }
        );
    },

    addTask: function({ commit }, { task, listId }) {
        return projectsApi.addTask(listId, task).then(
            response => {
                commit('addTask', { task: response.data, listId: listId });
            },
            error => {
                console.log('addTask error', { ...error });
            }
        );
    },

    editTask: function({ commit }, { task, listId }) {
        return projectsApi.editTask(listId, task.id, task).then(
            () => {
                commit('editTask', { task, listId });
            },
            error => {
                console.log('editTask error', { ...error });
            }
        );
    },

    deleteTask: function({ commit }, { task, listId }) {
        return projectsApi.deleteTask(listId, task.id).then(
            () => {
                commit('deleteTask', { task, listId });
            },
            error => {
                console.log('deleteTask error', { ...error });
            }
        );
    },

    toggleTaskComplete: ({ commit }, { task, listId }) => {
        if (!task.complete) {
            // Mark task complete
            return projectsApi.markTaskComplete(listId, task.id).then(
                () => {
                    commit('toggleTaskComplete', { task, listId });
                },
                error => {
                    console.log('toggleTaskComplete error', { ...error });
                }
            );
        } else {
            // Mark task NOT complete
            return projectsApi.markTaskNotComplete(listId, task.id).then(
                () => {
                    commit('toggleTaskComplete', { task, listId });
                },
                error => {
                    console.log('toggleTaskComplete error', { ...error });
                }
            );
        }
    },

    getProjectUploadStatus: ({ commit }, { projectId }) => {
        return new Promise((resolve, reject) => {
            projectsApi.getProjectUploadStatus(projectId).then(
                response => {
                    commit('setUploadStatus', response.data);
                    resolve(response.data);
                },
                error => {
                    commit('setUploadStatus', null);
                    console.log('getProjectUploadStatus error', { ...error });
                    reject(error);
                }
            );
        });
    },

    setNumberOfSelectedFiles: ({ commit }, number) => {
        commit('setNumberOfSelectedFiles', number);
    },

    resetStoreModuleData: ({ commit }) => {
        commit('resetStoreModuleData');
    }

    //#endregion
};
